// App.tsx
import React, {useState, useEffect, useCallback, useRef} from 'react';
import {useSnapshot} from 'valtio';
import {Modal, Select, Space, Tag, UploadFile,message} from 'antd';
import Markdown from 'react-markdown';
import SSEComponent from '@/components/SSEComponent';
import {sseStore} from '@/utils/store/store';
import DocxParser from '@/pages/AfterMeet/DocxParser';
import {DeleteOutlined} from '@ant-design/icons';
import dayjs from 'dayjs';
import AudioParser from '@/pages/AfterMeet/AudioParser';
import DropZoneOverlay from '@/pages/AfterMeet/DropZoneOverlay';
import {
  parseDocxFile,
  uploadAndTranscribeAudio,
  isValidDocumentFile,
  isValidAudioFile,
  isAudioFileSizeValid,
  getFileValidationError,
  SUPPORTED_AUDIO_EXTENSIONS,
} from '@/utils/file-upload';
import {UploadChangeParam} from 'antd/es/upload';
import {visitor} from '@/utils/store/visitor';
import {useAuth0} from '@auth0/auth0-react';
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';
import Industry from './static/Industry.png';
import template from './static/template.png';
import TemplateCard from '@/pages/AfterMeet/compment/TemplateCard';
import logo1 from "@/pages/AfterMeet/static/MianType/Notes.png";
import logo2 from "@/pages/AfterMeet/static/MianType/Copy-one.png";
import logo3 from "@/pages/AfterMeet/static/MianType/Comments.png";
import logo4 from "@/pages/AfterMeet/static/MianType/Star.png";
import logo5 from "@/pages/AfterMeet/static/MianType/action.png";

import {CiCircleList} from 'react-icons/ci';
import {IoChatbubblesOutline, IoCheckmarkCircleOutline} from 'react-icons/io5';
import {ERROR_MESSAGES, STATUS_MESSAGES, SUCCESS_MESSAGES, FILE_CONSTANTS} from '@/constants/messages';
import {handleError, handleSuccess} from '@/utils/helpers';
import { SubmitParams, checkSubmitParams } from '@/@types/submitParams';
import {FaCircleArrowUp} from "react-icons/fa6";
import {handleWarn} from "@/utils/ui-helpers";
import TemplateCardComment from "@/pages/AfterMeet/compment/TemplateCardComment";
import {SlDoc, SlDocs} from "react-icons/sl";
import {TbWorld} from "react-icons/tb";
import { TemplateType } from '@/constants/templateTypes';
import submit from "@/pages/AfterMeet/static/submit.png";
import OnlineMeetModal from '@/pages/OnlineMeet';
import { AuthStore } from "@/utils/store/auth";
import AddTemplateCard from '@/pages/AfterMeet/compment/AddTemplateCard';
import AddTemplateModal from '@/pages/AfterMeet/compment/AddTemplateModal';
import TemplateCardUD from '@/pages/AfterMeet/compment/TemplateCardUD';
import { CustomTemplateStore } from '@/utils/store/customTemplate';
import CommonLoading from '@/components/CommonLoading';
import { useSnapshot as useCustomTemplateSnapshot } from 'valtio';
import ScenarioTemplateCard from '@/pages/AfterMeet/compment/ScenarioTemplateCard';
import { ScenarioType, SCENARIO_METADATA } from '@/constants/scenarioTypes';
import TranscriptionPreviewModal from '@/pages/AfterMeet/compment/TranscriptionPreviewModal';

// 文件分隔符常量
const FILE_SEPARATORS = {
  FILE_PREFIX: '\n\n以下是相关文件内容（每一个文件的内容末尾以 -----\n 作为结束标记）：',
  AUDIO_PREFIX: '\n\n以下是相关会议录音转写文字等内容（每一个录音转录的内容末尾以 -----\n 作为结束标记）：',
  CONTENT_END: '-----\n',
};


const Main = ({ onSubmit, showActionBar = true }: { onSubmit?: () => void; showActionBar?: boolean }) => {
  const { trace, data, loading, error } = useSnapshot(sseStore);
  const [inputParams, setInputParams] = useState<Record<string, any>>({});

  const [TextFileInfo, setTextFileInfo] = useState<UploadChangeParam<UploadFile<any>> | null>(null);
  const [AudioFileInfo, setAudioFileInfo] = useState<UploadChangeParam<UploadFile<any>> | null>(null);
  const [notice, setNotice] = useState<string>("");
  const { count } = useSnapshot(visitor);
  const [selectedKey, setSelectedKey] = useState("");
  const [onlineMeetVisible, setOnlineMeetVisible] = useState(false);
  // const [templateMode, setTemplateMode] = useState<'scenario' | 'classic'>('scenario'); // 模板模式：场景模式或经典模式
  const [templateMode, setTemplateMode] = useState<'scenario' | 'classic' | 'custom'>('classic'); // 模板模式：场景模式或经典模式

  // 只使用 Supabase 认证状态
  const supabaseAuth = useSnapshot(supabaseAuthStore);
  
  // 获取自定义模板状态
  const customTemplateState = useCustomTemplateSnapshot(CustomTemplateStore);
  const { data: customTemplates, isLoading: customTemplatesLoading } = customTemplateState;
    const { data: authData, isLoading: authLoading } = useSnapshot(AuthStore);
  
  // 认证相关状态
  const { user, isAuthenticated, isLoading: isAuthLoading } = supabaseAuth;

  const isNotLogin = !supabaseAuth.isLoading && !supabaseAuth.isAuthenticated && supabaseAuth.user === undefined;
  const [addTemplateModalVisible, setAddTemplateModalVisible] = useState(false);
  
  // 音频上传中的状态（用于拖拽上传）
  const [isAudioUploading, setIsAudioUploading] = useState(false);
  // 转录预览弹窗状态
  const [transcriptionPreview, setTranscriptionPreview] = useState<{ visible: boolean; content: string; fileName: string }>({ visible: false, content: '', fileName: '' });
  // 文档解析内容（用于拖拽上传）
  const docParsedContentRef = useRef<Record<string, string>>({});

  // 草稿存储键名常量
  const DRAFT_STORAGE_KEY = 'meetAg_draft';

  /**
   * 从localStorage恢复草稿
   */
  const loadDraft = () => {
    const draft = localStorage.getItem(DRAFT_STORAGE_KEY);
    if (draft) {
      setInputParams(prev => ({ ...prev, Content: draft }));
    }
  };

  // 组件加载时检查是否有草稿
  useEffect(() => {
    const draft = localStorage.getItem(DRAFT_STORAGE_KEY);
    if (draft && !inputParams.Content) {
      // 只在初始加载且没有内容时显示按钮
    }
  }, []);

  // 加载用户自定义模板
  useEffect(() => {
    if (supabaseAuth.isAuthenticated && supabaseAuth.id) {
      CustomTemplateStore.runFetch(supabaseAuth.id);
    }
  }, [supabaseAuth.isAuthenticated, supabaseAuth.id]);

  // 切换模板模式时，清空当前选中的模板
  useEffect(() => {
    setSelectedKey('');
  }, [templateMode]);


  // 处理参数输入变化
  const handleParamChange = (key: string, value: string | Record<string, any>) => {
    setInputParams(prev => ({ ...prev, [key]: value }));
    // 自动保存草稿
    if (key === 'Content' && typeof value === 'string') {
      localStorage.setItem(DRAFT_STORAGE_KEY, value);
    }
  };

  /**
   * 处理拖拽上传的文档文件
   * 使用统一的 file-upload 服务
   */
  const handleDocumentDrop = useCallback(async (files: File[]) => {
    // 限制最多2个文件
    const filesToProcess = files.slice(0, FILE_CONSTANTS.MAX_UPLOAD_COUNT);
    
    for (const file of filesToProcess) {
      // 验证文件格式
      if (!isValidDocumentFile(file)) {
        const error = getFileValidationError(file, 'document');
        if (error) handleWarn(error);
        continue;
      }

      try {
        // 使用统一的解析方法
        const result = await parseDocxFile(file, file.name);
        docParsedContentRef.current[result.fileName] = result.content;
        handleParamChange('files', { ...docParsedContentRef.current });

        // 更新 TextFileInfo 状态（模拟 antd Upload 的格式）
        const uploadFile: UploadFile = {
          uid: `drop-${Date.now()}-${file.name}`,
          name: file.name,
          size: file.size,
          type: file.type,
          status: 'done',
        };
        
        setTextFileInfo(prev => ({
          file: uploadFile,
          fileList: [...(prev?.fileList || []), uploadFile],
        } as any));

      } catch (error) {
        // 错误已在 parseDocxFile 中处理
        console.error('Document parse error:', error);
      }
    }
  }, [handleParamChange]);

  /**
   * 处理拖拽上传的音频文件
   * 使用统一的 file-upload 服务
   */
  const handleAudioDrop = useCallback(async (files: File[]) => {
    // 检查登录状态
    if (isNotLogin) {
      handleError(null, `未登录不支持语音转录`);
      return;
    }

    // 检查是否已有音频在处理
    if (isAudioUploading) {
      handleWarn('当前有音频正在处理中，请稍后');
      return;
    }

    // 只取第一个音频文件
    const file = files[0];
    if (!file) return;

    // 验证文件格式
    if (!isValidAudioFile(file)) {
      const error = getFileValidationError(file, 'audio');
      if (error) handleWarn(error);
      return;
    }

    // 验证文件大小
    if (!isAudioFileSizeValid(file)) {
      handleError(null, '文件大小不能超过2GB');
      return;
    }

    // 创建 UploadFile 对象
    const uploadFile: UploadFile = {
      uid: `drop-audio-${Date.now()}`,
      name: file.name,
      size: file.size,
      type: file.type,
      status: 'uploading',
      percent: 0,
    };

    try {
      setIsAudioUploading(true);
      
      setAudioFileInfo({
        file: uploadFile,
        fileList: [uploadFile],
      } as any);

      // 使用统一的上传转录方法
      const result = await uploadAndTranscribeAudio(file, {
        onProgress: (progress) => {
          setAudioFileInfo(prev => ({
            ...prev,
            file: { ...uploadFile, percent: progress.percent },
            fileList: [{ ...uploadFile, percent: progress.percent }],
          } as any));
        },
        onStatusChange: (status) => {
          setNotice(status);
        },
      });

      // 转录成功，更新状态
      handleParamChange('parsedContent', { [result.fileName]: result.transcription });
      setAudioFileInfo(prev => ({
        ...prev,
        file: { ...uploadFile, status: 'done', percent: 100 },
        fileList: [{ ...uploadFile, status: 'done', percent: 100 }],
      } as any));

    } catch (error: any) {
      // 错误已在 uploadAndTranscribeAudio 中处理
      console.error('Audio upload error:', error);
      setNotice('');
      setAudioFileInfo(null);
    } finally {
      setIsAudioUploading(false);
    }
  }, [isNotLogin, isAudioUploading, handleParamChange]);



  // 提交参数到全局存储（带防抖）
  const updateParams = () => {

    // 正在转录时禁止提交
    if(notice !== "" && notice !== "转录完成"){
      handleWarn("转录进行中，请稍后操作");
      return;
    }

    console.log("update params", inputParams);
    inputParams["time"] = dayjs().format();


    let appendContentPre = '';
    const txtRecordList: Record<string, any> = (inputParams['files'] as Record<string, any>) || {};
    const textNum = txtRecordList ? Object.keys(txtRecordList).length : 0;
    if (textNum > 0) {
      appendContentPre = FILE_SEPARATORS.FILE_PREFIX;
      for (const txtKey of Object.keys(txtRecordList)) {
        appendContentPre += txtRecordList[txtKey];
        appendContentPre += FILE_SEPARATORS.CONTENT_END;
      }
      console.log('追加内容：' + appendContentPre);
    }

    let appendAudioContent = '';
    const audioRecordList: Record<string, any> = (inputParams['parsedContent'] as Record<string, any>) || {};
    const audioNum = audioRecordList ? Object.keys(audioRecordList).length : 0;
    if (audioNum > 0) {
      appendAudioContent = FILE_SEPARATORS.AUDIO_PREFIX;
      for (const audioKey of Object.keys(audioRecordList)) {
        appendAudioContent += audioRecordList[audioKey];
        appendAudioContent += FILE_SEPARATORS.CONTENT_END;
      }
      console.log('追加内容：' + appendAudioContent);
    }
    // let filesContent = inputParams['files']

  
      
    let User_Define_Template = "";
    let Output_type = selectedKey;
        
    // 判断是否为自定义模板
    const isCustomTemplate = selectedKey.startsWith('custom_');
    if (isCustomTemplate) {
      User_Define_Template = customTemplates.find(template => template.id === (selectedKey.replace("custom_","")))?.info || "";
      Output_type = TemplateType.CUSTOM;
    }

    const filesNum = (audioNum+textNum);
    const submitParams: SubmitParams = {
      ...inputParams, // 先展开保留其他字段
      Content: inputParams['Content'] + appendContentPre + appendAudioContent,
      Output_type,
      textNum: textNum.toString(),
      audioNum: audioNum.toString(),
      files: filesNum ? "true" : "",
      User_Define_Template,
    };

    if (isNotLogin) {
      if (count > 0) {
        visitor.useFeature();
      } else {
        handleError(null, ERROR_MESSAGES.GUEST_LIMIT_EXCEEDED, 'main');
        return;
      }
    }

    // console.log("134");
    // console.log(textNum);
    // console.log(audioNum);

    let isLegal = checkSubmitParams(submitParams, 'Industry', 'Content', 'Output_type');
    if(!isLegal){
      handleWarn("必填项为空，请补充");
      return;
    }

    // console.log(submitParams);

    sseStore.data = '';
    sseStore.params = submitParams;
    sseStore.requestId = `req_${Date.now()}`;

    // 提交成功后清空草稿
    localStorage.removeItem(DRAFT_STORAGE_KEY);

    // 通知父组件滚动到结果区域
    onSubmit?.();
  };


  return (
      <>
        {/* <SSEComponent url="/sse" /> */}
        {/* SSEComponent 已移至 index.tsx，避免表单隐藏时中断连接 */}

        <div className="bg-white relative pb-32">
          {/* 在线会议按钮 - 右上角徽标形式 - 已隐藏 */}
          {/* {
            !isAuthLoading 
            // && authData?.isSuperAdmin
            &&
            <button
              onClick={() => setOnlineMeetVisible(true)}
              className="absolute top-4 right-4 btn btn-primary btn-xs z-10 shadow-lg"
              title="在线会议卡"
            >
              📝在线会议卡
            </button>
          } */}
          
          {/* Top Header */}
          <header className="w-full flex justify-between items-center px-12 py-8">
            <h1 className="text-2xl font-bold tracking-tight">开始整理记录～</h1>
            <div></div>
          </header>

          <div className="w-full max-w-5xl mx-auto px-12 flex flex-col gap-10">


            {/* Input Area */}
            <section className="space-y-4">
            <div
                className="group"
                // tabIndex="0"
            >
              {/* 草稿恢复按钮 */}
              {localStorage.getItem(DRAFT_STORAGE_KEY) && !inputParams.Content && (
                <div className="mb-2">
                  <button
                    onClick={loadDraft}
                    className="btn btn-xs btn-outline btn-secondary"
                  >
                    恢复上次草稿？
                  </button>
                </div>
              )}
              {/* 输入框容器：textarea + 上传按钮在同一个边框内 */}
              <div className="border border-[#E9E9E7] rounded-2xl overflow-hidden focus-within:border-[#D1D1CF] focus-within:shadow-[0_0_0_2px_rgba(0,0,0,0.02)] transition-all">
                <textarea className="w-full min-h-[200px] p-8 pb-4 text-base leading-relaxed focus:outline-none focus:ring-0 focus:shadow-none resize-none placeholder:text-[#91918E] border-none"
                          placeholder="请输入会议笔记、初稿或速记内容，下方可上传录音转录稿等补充材料。"
                          value={inputParams.Content}
                          onChange={(e) => handleParamChange("Content", e.target.value)}
                ></textarea>
                {/*<div className={"p-1 pb-3 pl-3 tooltip "} >*/}
                {/*</div>*/}

                {/* 上传按钮 - 输入框内部底部 */}
                <div className={"px-8 pb-6 flex gap-3"}>
                  <div className="flex items-center gap-1.5 px-3 py-1.5 border border-[#E9E9E7] bg-white rounded-lg text-[11px] text-[#73726E] hover:bg-zinc-50 cursor-pointer">
                    <DocxParser fList={TextFileInfo?.fileList} fileChange={(fileInfo: UploadChangeParam<UploadFile<any>>) => setTextFileInfo(fileInfo)} setData={(docParam: Record<string, any>) => handleParamChange("files", docParam)} />
                  </div>
                  <div className="flex items-center gap-1.5 px-3 py-1.5 border border-[#E9E9E7] bg-white rounded-lg text-[11px] text-[#73726E] hover:bg-zinc-50 cursor-pointer">
                    <AudioParser fList={AudioFileInfo?.fileList} setA2tNotice={setNotice} fileChange = {(fileInfo: UploadChangeParam<UploadFile<any>>) => setAudioFileInfo(fileInfo)}  setData={(docParam: Record<string, any>) => handleParamChange("parsedContent", docParam)} />
                  </div>
                </div>
              </div>

              {/* 已上传文本文件列表 */}
              <div className="mt-3 space-y-2 px-1">
                {
                  TextFileInfo && TextFileInfo.fileList && TextFileInfo.fileList.length > 0 &&
                  TextFileInfo.fileList.map((file, index) => (
                    <div key={index} className="flex items-center gap-3 px-4 py-2.5 bg-[#FBFBFA] border border-[#E9E9E7] rounded-xl group">
                      <div className="flex items-center justify-center w-8 h-8 bg-[#F7F7F5] rounded-lg flex-shrink-0">
                        <svg className="w-4 h-4 text-[#91918E]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
                        </svg>
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="text-sm text-[#37352F] truncate">{file.name}</div>
                        <div className="text-[11px] text-[#91918E]">{((file.size || 0) / 1024).toFixed(1)} KB</div>
                      </div>
                      <button
                        className="w-7 h-7 flex items-center justify-center rounded-lg text-[#C3C2BF] hover:text-red-400 hover:bg-red-50 opacity-0 group-hover:opacity-100 transition-all cursor-pointer"
                        onClick={()=>{
                          setTextFileInfo({
                            ...TextFileInfo,
                            fileList: TextFileInfo.fileList.filter((_, i) => i !== index),
                          });

                          const txtFields: Record<string, any> = (inputParams['files'] as Record<string, any>) || {}
                          if(txtFields ) {
                            delete txtFields[file.name]
                          }
                          handleParamChange("files", txtFields)
                        }}
                      >
                        <DeleteOutlined className="text-xs" />
                      </button>
                    </div>
                  ))
                }
              </div>
              {/* 已上传音频文件列表 */}
              <div className="space-y-2 px-1">
                {
                  AudioFileInfo && AudioFileInfo.fileList && AudioFileInfo.fileList.length > 0 &&
                  AudioFileInfo.fileList.map((file, index) => (
                    <div key={index}>
                      <div className="flex items-center gap-3 px-4 py-2.5 bg-[#FBFBFA] border border-[#E9E9E7] rounded-xl group">
                        <div className="flex items-center justify-center w-8 h-8 bg-[#F7F7F5] rounded-lg flex-shrink-0">
                          <svg className="w-4 h-4 text-[#91918E]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
                          </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="text-sm text-[#37352F] truncate">{file.name}</div>
                          <div className="flex items-center gap-2">
                            <span className="text-[11px] text-[#91918E]">{((file.size || 0) / 1024 / 1024).toFixed(2)} MB</span>
                            {notice && <span className="text-[11px] text-[#73726E]">{notice}</span>}
                          </div>
                        </div>
                        {/* 预览按钮 */}
                        {
                          notice === "转录完成" && <button
                            className="px-2.5 py-1 text-[11px] text-[#73726E] bg-[#F7F7F5] hover:bg-[#EDEDEC] rounded-lg transition-colors cursor-pointer"
                            onClick={() => {
                              const previewContent = (inputParams['parsedContent'] as Record<string, any>)?.[file.name] || '';
                              setTranscriptionPreview({ visible: true, content: previewContent, fileName: file.name });
                            }}
                          >预览</button>
                        }
                        {/* 删除按钮 */}
                        <button
                          className="w-7 h-7 flex items-center justify-center rounded-lg text-[#C3C2BF] hover:text-red-400 hover:bg-red-50 opacity-0 group-hover:opacity-100 transition-all cursor-pointer"
                          onClick={()=>{
                            setAudioFileInfo({
                              ...AudioFileInfo,
                              fileList: AudioFileInfo.fileList.filter((_, i) => i !== index),
                            });
                            const audioFields: Record<string, any> = (inputParams['parsedContent'] as Record<string, any>) || {}
                            if(audioFields ) {
                              delete audioFields[file.name]
                            }
                            handleParamChange("parsedContent", audioFields)
                            setNotice("")
                          }}
                        >
                          <DeleteOutlined className="text-xs" />
                        </button>
                      </div>
                      {/* 上传进度条 */}
                      {file.percent !== undefined && file.percent < 100 && (
                        <div className="mt-1.5 mx-4">
                          <div className="h-1 bg-[#E9E9E7] rounded-full overflow-hidden">
                            <div className="h-full bg-[#37352F] rounded-full transition-all duration-300" style={{ width: `${file.percent}%` }} />
                          </div>
                        </div>
                      )}
                      {notice === STATUS_MESSAGES.TRANSCRIBING && (
                        <div className="mt-1.5 mx-4">
                          <div className="h-1 bg-[#E9E9E7] rounded-full overflow-hidden">
                            <div className="h-full bg-[#37352F] rounded-full animate-pulse w-full" />
                          </div>
                        </div>
                      )}
                    </div>
                  ))
                }
              </div>

            </div>
            </section>


            <section className="w-full max-w-sm">
              <div className="space-y-2">
                <label className="text-sm font-semibold flex items-center gap-2">
                  <TbWorld className="text-[18px] text-[#73726E]" />
                  行业领域
                </label>
            <Select
                variant="borderless"
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: '100%',
                  backgroundColor: "#FBFBFA",
                  border: "1px solid #E9E9E7",
                  borderRadius: "12px",
                  fontSize: "14px"
                }}
                className="rounded-xl h-10 flex-none"
                placeholder="选择行业领域，确保纪要符合行业特点"
                onChange={(value) => handleParamChange("Industry", value)}
                popupClassName="custom-select-dropdown"
                options={[
                  { value: "企业服务", label: <span>企业服务</span> },
                  { value: "消费文娱电商", label: <span>消费文娱电商</span> },
                  { value: "金融", label: <span>金融</span> },
                  { value: "半导体", label: <span>半导体</span> },
                  { value: "信息科技", label: <span>信息科技</span> },
                  { value: "材料", label: <span>材料</span> },
                  { value: "能源", label: <span>能源</span> },
                  { value: "制造", label: <span>制造</span> }
                ]} />
                <p className="text-[10px] text-[#91918E] px-1">选择行业领域，确保纪要符合行业特点</p>
              </div>
            </section>

            <section className="space-y-6">
              <div className="flex items-center justify-between border-b border-[#E9E9E7]">
                <div className="flex gap-8">
                  <button 
                    className={`text-sm pb-3 -mb-[2px] transition-colors ${templateMode === 'classic' ? 'font-bold border-b-2 border-black' : 'font-medium text-[#91918E] hover:text-black'}`}
                    onClick={() => setTemplateMode('classic')}
                  >
                    经典模式
                  </button>
                  <button 
                    className={`text-sm pb-3 -mb-[2px] transition-colors ${templateMode === 'scenario' ? 'font-bold border-b-2 border-black' : 'font-medium text-[#91918E] hover:text-black'}`}
                    onClick={() => setTemplateMode('scenario')}
                  >
                    场景模式
                  </button>
                  <button 
                    className={`text-sm pb-3 -mb-[2px] transition-colors ${templateMode === 'custom' ? 'font-bold border-b-2 border-black' : 'font-medium text-[#91918E] hover:text-black'}`}
                    onClick={() => setTemplateMode('custom')}
                  >
                    自定义模式
                  </button>
                </div>
              </div>

            <div className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 w-full"}>
              {/* 场景模式 - 显示场景模板 */}
              {templateMode === 'scenario' && (
                <>
                  {/* 添加自定义模板按钮 - 仅登录用户可见，且非加载状态 */}
                  {/* <AddTemplateCard
                    onClick={() => {
                      if(isAuthenticated && !customTemplatesLoading){
                        setAddTemplateModalVisible(true)
                      } else {
                        message.warning('请先登录')
                      }
                    }}
                  /> */}

                  {/* 自定义模板卡片 */}
                  {/* {customTemplatesLoading ? (
                    <div className="w-56 h-44 flex items-center justify-center">
                      <CommonLoading />
                    </div>
                  ) : (
                    customTemplates.map((template) => (
                      <TemplateCardUD
                        key={template.id || `${template.userId}-${template.title}`}
                        id={template.id}
                        title={template.title}
                        info={template.info}
                        userId={template.userId}
                        value={`custom_${template.id}`}
                        curKey={selectedKey}
                        sk={setSelectedKey}
                      />
                    ))
                  )} */}
                  
                  {/* 场景模板 */}
                  {Object.values(ScenarioType).map((scenarioType) => (
                    <ScenarioTemplateCard
                      key={scenarioType}
                      value={scenarioType}
                      iconName={SCENARIO_METADATA[scenarioType].iconName}
                      title={scenarioType}
                      desc={SCENARIO_METADATA[scenarioType].desc}
                      curKey={selectedKey}
                      sk={setSelectedKey}
                    />
                  ))}
                </>
              )}
              
              {/* 经典模式 - 显示经典模板 */}
              {templateMode === 'classic' && (
                <>
                  {/* 添加自定义模板按钮 - 仅登录用户可见，且非加载状态 */}
                  {/* <AddTemplateCard
                    onClick={() => {
                      if(isAuthenticated && !customTemplatesLoading){
                        setAddTemplateModalVisible(true)
                      } else {
                        message.warning('请先登录')
                      }
                    }}
                  /> */}

                  {/* 自定义模板卡片 */}
                  {/* {customTemplatesLoading ? (
                    <div className="w-56 h-44 flex items-center justify-center">
                      <CommonLoading />
                    </div>
                  ) : (
                    customTemplates.map((template) => (
                      <TemplateCardUD
                        key={template.id || `${template.userId}-${template.title}`}
                        id={template.id}
                        title={template.title}
                        info={template.info}
                        userId={template.userId}
                        value={`custom_${template.id}`}
                        curKey={selectedKey}
                        sk={setSelectedKey}
                      />
                    ))
                  )} */}
                  
                  {/* 经典模板 */}
                  <TemplateCard value={TemplateType.DEEP} img={logo1} title={"深度纪要"} desc={"逻辑重构 详细记录"} curKey={selectedKey} sk={setSelectedKey} More={null} />
                  {/* <TemplateCard value={TemplateType.DEEP_MULTI} img={logo2} title={"深度纪要（多源版）"} desc={"逻辑重构 详细记录"} curKey={selectedKey} sk={setSelectedKey} More={
                    ()=><TemplateCardComment desc={"适用: 笔记和录音稿等多种资料一起整理"} colorBg={"rgba(112,86,255,0.2)"} colorP={"6A51FF"} className={"h-5"}/>
                  }/> */}
                  <TemplateCard value={TemplateType.DIALOGUE} img={logo3} title={"对话纪要"} desc={"全貌还原 问答记录"} curKey={selectedKey} sk={setSelectedKey} More={null}/>
                  <TemplateCard value={TemplateType.KEY_POINTS} img={logo4} title={"要点概述"} desc={"关键提炼 快速浏览"} curKey={selectedKey} sk={setSelectedKey} More={null}/>
                  <TemplateCard value={TemplateType.TASK_ASSIGNMENT} img={logo5} title={"行动计划"} desc={"任务分配 待办事项"} curKey={selectedKey} sk={setSelectedKey} More={null}/>
                </>
              )}

              {templateMode === 'custom' && (
                <>
                  {/* 添加自定义模板按钮 - 仅登录用户可见，且非加载状态 */}
                  <AddTemplateCard
                    onClick={() => {
                      if(isAuthenticated && !customTemplatesLoading){
                        setAddTemplateModalVisible(true)
                      } else {
                        message.warning('请先登录')
                      }
                    }}
                  />

                  {/* 自定义模板卡片 */}
                  {customTemplatesLoading ? (
                    <div className="w-56 h-44 flex items-center justify-center">
                      <CommonLoading />
                    </div>
                  ) : (
                    customTemplates.map((template) => (
                      <TemplateCardUD
                        key={template.id || `${template.userId}-${template.title}`}
                        id={template.id}
                        title={template.title}
                        info={template.info}
                        userId={template.userId}
                        value={`custom_${template.id}`}
                        curKey={selectedKey}
                        sk={setSelectedKey}
                      />
                    ))
                  )}
                  
                  
                </>
              )}
              
            </div>

            {/* 主提交按钮 - Notion 风格浮动操作栏 */}
            </section>


            <div className="card-actions justify-end mt-0">

              <Space>
                {/* <Button*/}
                {/*  // type="primary"*/}
                {/*  variant="solid"*/}
                {/*  color="default"*/}
                {/*  onClick={updateParams}*/}
                {/*  loading={loading}*/}
                {/*  disabled={loading}*/}
                {/*>*/}
                {/*  会议整理*/}
                {/*</Button>*/}
                {/*<Button*/}
                {/*  // type="primary"*/}
                {/*  onClick={() => {*/}
                {/*    sseStore.data = "";*/}
                {/*  }}*/}
                {/*>*/}
                {/*  清空*/}
                {/*</Button> */}
              </Space>
            </div>
          </div>

          


        </div>

        {/* Floating Action Bar - 参考设计的浮动底栏，由父组件控制显隐 */}
        {showActionBar && <div className="fixed bottom-0 right-0 px-8 py-[35px] bg-white/80 backdrop-blur-xl border-t border-[#E9E9E7] flex justify-center items-center gap-16 z-20" style={{ left: 'var(--sidebar-width)' }}>
          <div className="flex items-center gap-2 text-[#91918E] text-sm">
            <span>{selectedKey ? `已选择模板：${selectedKey}` : '请选择模板'}</span>
          </div>
          <button
            onClick={updateParams}
            disabled={loading}
            className={`px-12 py-4 rounded-full font-bold text-sm transition-all shadow-xl flex items-center gap-3 group cursor-pointer ${
              loading ? 'bg-gray-300 text-gray-500 cursor-not-allowed' :
              'bg-black text-white hover:scale-105 active:scale-95'
            }`}
          >
            {loading ? (
              <>
                <span className="loading loading-spinner loading-sm"></span>
                处理中...
              </>
            ) : (
              '开始整理'
            )}
          </button>
        </div>}

        {/* 在线会议弹窗 */}
        <OnlineMeetModal 
          visible={onlineMeetVisible}
          onClose={() => setOnlineMeetVisible(false)}
          onMeetingEnd={(notes: string, transcription: string) => {
            // 会议结束后，将笔记和转录内容添加到输入框下方
            const meetingContent = `

=== 会议笔记 ===
${notes}

=== 实时转录 ===
${transcription}`;
            handleParamChange("Content", (inputParams.Content || "") + meetingContent);
            setOnlineMeetVisible(false);
          }}
        />

        {/* 自定义模板添加弹窗 */}
        <AddTemplateModal
          visible={addTemplateModalVisible}
          onClose={() => setAddTemplateModalVisible(false)}
          userId={supabaseAuth.id || ''}
        />

        {/* 拖拽上传浮层 */}
        <DropZoneOverlay
          onDocumentDrop={handleDocumentDrop}
          onAudioDrop={handleAudioDrop}
          disabled={loading || isAudioUploading}
        />

        {/* 转录文本预览弹窗 */}
        <TranscriptionPreviewModal
          visible={transcriptionPreview.visible}
          content={transcriptionPreview.content}
          fileName={transcriptionPreview.fileName}
          onClose={() => setTranscriptionPreview({ visible: false, content: '', fileName: '' })}
        />

      </>
  );
};

export default Main;